<template>
  <shopmall-tip
    location="bottom"
    icon="mdi-help-circle-outline"
    color="#00000099"
    width="340"
    :max-width="360"
  >
    <div class="product-public-style">
      <product-price
        :product="product"
        :price-info="product.productPrice"
        :sample-flag="product.sampleFlag === 1"
        :has-shipping-text="hasShippingText"
        :has-blank-or-sample="['Blank', 'Sample'].includes(product.productPrinting.printingWay)"
        :erp-order-has-blank-or-sample="source===2&&['Blank', 'Sample'].includes(product.productPrinting.printingWay)&&product.productPrice.setUpCharge>0"
        :has-other-fee="source===2&&product.otherCharge>0"
        :has-charge-fees="source===2&&!useIsContainChinese(product.chargeFees)"
      ></product-price>
    </div>
  </shopmall-tip>
</template>

<script setup>
const props = defineProps({
  product: {
    type: Object,
    default: () => ({})
  },
  hasShippingText: {
    type: Boolean,
    default: false
  },
  source: {
    type: Number,
    default: null
  },
});

const show = ref(false);
</script>

<style lang="scss" scoped>
.mdi-help-circle-outline {
  position: relative;
  top: -1px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 20px;
}
div.tip-wrapper {
  min-width: 300px;
  color: rgba(0, 0, 0, 0.6);
}
div.item {
  display: flex;
  & > span {
    flex: 1;
    text-align: right;
    &.label {
      text-align: left;
      font-weight: 650;
    }
  }
}
</style>
